import React from "react";

export const Footer = ({ children }) => {
  return (
    <div className="tw-flex tw-items-center tw-justify-between tw-p-[14px_16px_12px_16px] tw-gap-[10px] tw-border-t tw-border-[#E7E6EA] tw-border-solid tw-border-0">
      {children}
    </div>
  );
};
